import { ITableSetting } from "../../../../Table/BasicTable";
import { CMSCollection } from "../../../../../models/CMS/cmsCollection";
import { IconWrapper } from "../../../ui-components/pageLayout/TableSettingsComponents";
import { MdModeEditOutline } from "react-icons/md";
import React from "react";

export const CollectionsPageTableSettings: ITableSetting<CMSCollection>[] = [
  {
    id: "name-id",
    align: "left",
    name: "NAME",
    path: "NAME",
    content: (data: CMSCollection) => <div>{data.getDisplayName()}</div>,
  },
  {
    id: "id-id",
    align: "left",
    name: "ID",
    path: "ID",
    content: (data: CMSCollection) => <div>{data.getUniqueId()}</div>,
  },
  {
    id: "desc-id",
    align: "left",
    name: "description",
    path: "description",
    content: (data: CMSCollection) => <div>{data.description}</div>,
  },
  {
    id: "published-id",
    align: "center",
    name: "PUBLISHED",
    path: "PUBLISHED",
    content: (data: CMSCollection) => (
      <input type="checkbox" readOnly checked={data.isPublished} />
    ),
  },
  {
    id: "created-id",
    align: "left",
    name: "CREATED",
    path: "CREATED",
    content: (data: CMSCollection) => <div>{data.createdDate}</div>,
  },
  {
    id: "changed-id",
    align: "left",
    name: "CHANGED",
    path: "CHANGED",
    content: (data: CMSCollection) => <div>{data.changedDate}</div>,
  },
  {
    id: "edit-id",
    align: "right",
    name: "",
    path: "gh",
    content: (data: CMSCollection) => (
      <IconWrapper>
        <MdModeEditOutline />
      </IconWrapper>
    ),
  },
];
